__turbopack_context__.v({
  "container": "PrefillSelector-module__gKiq6a__container",
  "group": "PrefillSelector-module__gKiq6a__group",
  "groupItem": "PrefillSelector-module__gKiq6a__groupItem",
  "item": "PrefillSelector-module__gKiq6a__item",
  "itemSelected": "PrefillSelector-module__gKiq6a__itemSelected",
  "roundButton": "PrefillSelector-module__gKiq6a__roundButton",
  "tooltip": "PrefillSelector-module__gKiq6a__tooltip",
  "tooltipTitle": "PrefillSelector-module__gKiq6a__tooltipTitle",
});
